module.exports = __webpack_public_path__ + "img/Wp_2057.4301e1c5.png";